<template>
  <div class="tab">
    <div
      class="item"
      v-for="item in tabs"
      v-bind:key="item.id"
      :class="[item.class,item.id==active?activeClass:'']"
      v-on:click="go(item)"
    >
      <i class="iconfont" :class="item.icon"></i>
      <div v-if="item.dot>0" class="dot">{{item.dot}}</div>
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: "DPtabbar",
  props: ["active"],
  data() {
    return {
      user: { token: "" },

      activeClass: "active",
      tabs: [
        {
          id: 0,
          name: "首页",
          icon: "iconhome",
          url: "/",
          class: "home",
          dot: 0
        },
        
        {
          id: 2,
          name: "亿起抢",
          icon: "icon42",
          url: "/qiang/list",
          class: "add",
          dot: 0
        },
        {
          id: 3,
          name: "闲置",
          icon: "iconlie-b",
          url: "/second/list",
          class: "msg",
          dot: 0
        },
        {
          id: 1,
          name: "邻友汇",
          icon: "iconyouhuiquan1",
          url: "/community/index",
          class: "hui",
          dot: 0
        },
        {
          id: 4,
          name: "我的",
          icon: "iconusercenter_icon_yonghuxin",
          url: "/user",
          class: "hui",
          dot: 0
        }
      ]
    };
  },
  methods: {
    go(v) {
      //   this.active = v.id;
      this.$router.push(v.url);
    },
    data(){
        return{
            interval:''
        }
    },
    
  },
  mounted() {
    
  },
  destroyed(){
  }
};
</script>

<style lang="scss" scoped>
.dot {
  background-color: red;
  border-radius: 15px;
  position: absolute;
  top: 0px;
  left: 50%;
  margin-left: 8px;
  padding: 0 5px 0 5px;
  color:#fff;
}
.tab {
  //background-color: #fff;
  //background: linear-gradient(to right,#780001,#d3512f,#780001);
  background: linear-gradient(to right,#1baeae,#e2f5f5,#1baeae);
  //background: linear-gradient(to right,#c02c38,#c02c38,#c02c38);
  //background: linear-gradient(to right,#CBC9CC,#fff,#CBC9CC);
  //background: linear-gradient(to right,
	// 		rgba(189, 7, 7, 1) 30%,
	// 		rgba(252, 4, 4, 1) 50%,
	// 		rgba(189, 7, 7, 1) 80%,
  //     );
  height: 60px;
  overflow: hidden;
  border-top: 1px solid #ebedf0;
  box-sizing: border-box;
  padding: 5px 0 10px 0;
  position: fixed;
  bottom: 0;
  font-size: 12px;
  //color: #7d7e80;
  color: #333;
  // color: #fff;
  display: flex;
  width: 100%;
  .item {
    position: relative;
    .iconfont {
      height: 30px;
      line-height: 30px;
      display: block;
      font-size: 23px;
      ///color: #7d7e80;
      //color: #666;
      color: #222333;
    }
    width: 20%;
    text-align: center;
  }

  .active {
    font-size: 13px;
    //color: #fb8e0f;
    color: #fff;
    .iconfont {
      //color: #fb8e0f;
      color: #fff;
    }
  }
}
</style>